import { Box, Eye } from "lucide-react";
import { isUiModeDeveloper, uiModeWatcher } from "../../../src/uiMode";
import { itx } from "../../../src/translationItx/itx";
import { Button3DDialog } from "./Button3DDialog";
import type Button from "../../../src/models/Button";
import { useOnChangeWatcher } from "../../../src/models/useOnChangeWatcher";
import { getButton3DViewData, type Button3DViewContext } from "./button3DViewData";
import "./modelView.scss";

export interface Button3DPreviewProps extends Button3DViewContext {
  button: Button;
  compact?: boolean;
}

export function C1_Button3DPreview({ button, page, press, compact = false }: Button3DPreviewProps) {
  useOnChangeWatcher(uiModeWatcher);
  useOnChangeWatcher(button);
  useOnChangeWatcher(button.template);
  useOnChangeWatcher(button.template?.knxProductData);
  useOnChangeWatcher(button.channels);
  const { model } = getButton3DViewData(button, { page, press });
  if (!isUiModeDeveloper() || !model) return null;
  return <div className={compact ? undefined : "C1_button3DPreview"}
    style={compact ? { display: "contents" } : undefined} onClick={event => event.stopPropagation()}>
    <button type="button" className={compact ? "dockIconButton" : undefined}
      aria-label={itx("c1.button3d.open", "3D-Vorschau")}
      data-tooltip-id="tv-tooltip" data-tooltip-content={itx("c1.button3d.open", "3D-Vorschau")}
      data-testid="c1-button-3d-preview" onClick={() => {
        void state.dialogManager.openDialog(<Button3DDialog button={button} page={page} press={press} />, true);
      }}>
      {compact ? <Eye size={18} aria-hidden="true" /> : <><Box size={16} aria-hidden="true" /> {itx("c1.button3d.open", "3D-Vorschau")}</>}
    </button>
  </div>;
}
